import { Box, SpaceBetween } from "@amzn/awsui-components-console";

import { useCart } from "@/contexts/CartContext";
import { formatUnits } from "@/utils/utils";

import useModal from "../useModal";

const useClearCartModal = () => {
  const { items, clearCart } = useCart();
  return useModal({
    title: "Clear Cart",
    onConfirm: clearCart,
    content: (
      <SpaceBetween size="m">
        <Box>
          This will remove all {items.length}{" "}
          {formatUnits(items.length, "clip")}. Are you sure you want to proceed?
        </Box>
      </SpaceBetween>
    ),
  });
};

export default useClearCartModal;
